"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var pages_1 = require("../redux/pages");
var PageButton_1 = require("./PageButton");
require("./style/PagesMenu.css");
var PagesMenu = /** @class */ (function (_super) {
    __extends(PagesMenu, _super);
    function PagesMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { opened: false };
        return _this;
    }
    PagesMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentPage = _a.currentPage, setCurrentPage = _a.setCurrentPage;
        var opened = this.state.opened;
        return (React.createElement("div", { className: "PagesMenu-container" },
            React.createElement(PageButton_1.default, { className: "PagesMenu-current-button", page: currentPage, onClick: function () { return _this.setState({ opened: !opened }); } }),
            React.createElement("div", { className: "PagesMenu-background" + (opened ? "" : "-hidden"), onClick: function () { return _this.setState({ opened: false }); } }),
            React.createElement("div", { className: "PagesMenu-box" + (opened ? "" : "-hidden") }, pages_1.pages.map(function (page) {
                return React.createElement(PageButton_1.default, { key: page, className: page === currentPage && "PagesMenu-disabled-button", page: page, onClick: function () {
                        setCurrentPage(page);
                        _this.setState({ opened: false });
                    } });
            }))));
    };
    return PagesMenu;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var pages = _a.pages;
    return pages;
}, pages_1.actionCreators)(PagesMenu);



//////////////////
// WEBPACK FOOTER
// ./src/component/PagesMenu.tsx
// module id = 495
// module chunks = 0